import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  'https://kaphy-insurance-api-24bfecb5d4bb.herokuapp.com';

const SESSION_KEY = 'kaphy_sid';

const getSessionId = () => {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

const usePageTracker = () => {
  const location = useLocation();
  const { isAdmin, isSuperAdmin } = useAuth();
  const lastPath = useRef(null);

  useEffect(() => {
    if (window.__PRERENDER__) return; // build-time headless crawl — don't log fake pageviews
    if (isAdmin || isSuperAdmin) return;
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;

    axios
      .post(`${API_BASE_URL}/api/analytics/track`, {
        page: location.pathname,
        referrer: document.referrer || '',
        sessionId: getSessionId(),
      })
      .catch(() => {});
  }, [location.pathname, isAdmin, isSuperAdmin]);
};

export default usePageTracker;
